/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomAttributeVisibilityOut
 */
export interface CustomAttributeVisibilityOut {
    /**
     * 
     * @type {string}
     * @memberof CustomAttributeVisibilityOut
     */
    offerId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomAttributeVisibilityOut
     */
    code: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomAttributeVisibilityOut
     */
    isVisible: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CustomAttributeVisibilityOut
     */
    modificationDate: Date;
}

export function CustomAttributeVisibilityOutFromJSON(json: any): CustomAttributeVisibilityOut {
    return CustomAttributeVisibilityOutFromJSONTyped(json, false);
}

export function CustomAttributeVisibilityOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAttributeVisibilityOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerId': json['offerId'],
        'code': json['code'],
        'isVisible': json['isVisible'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function CustomAttributeVisibilityOutToJSON(value?: CustomAttributeVisibilityOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offerId': value.offerId,
        'code': value.code,
        'isVisible': value.isVisible,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


